import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TabItem } from '../tab.utils';

@Component({
  selector: 'nk-tab',
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent<T> {
  @Input() public tabIndex: number | undefined;
  @Input() public tab: TabItem<T> | undefined;
  @Output() public tabClicked = new EventEmitter<number>();

  public clickTab(tabIndex: number | undefined): void {
    this.tabClicked.emit(tabIndex);
  }
}
